/**
 * @file Abstract class for input with upload functionality
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for the upload input component
 */
var UploadInput = /** @class */ (function (_super) {
    tslib_1.__extends(UploadInput, _super);
    /**
     * Constructs a UploadInput.
     * @param alertsService Service for giving user feedback
     */
    function UploadInput(alertsService, uploadService) {
        var _this = _super.call(this) || this;
        _this.alertsService = alertsService;
        _this.uploadService = uploadService;
        /** Are we in the middle of uploading */
        _this.isUploading = false;
        return _this;
    }
    /**
     * The change event indicates that the user has selected a local file
     * @param $event The event initiated by user
     */
    UploadInput.prototype.change = function ($event) {
        var _this = this;
        // Grab the user file
        var file = $event.target.files[0];
        this.fileName = file.name;
        this.isUploading = true;
        this.uploadService.validate(file).then(function (validatedFile) {
            return _this.uploadService.read(validatedFile).then(function (fileData) {
                return _this.uploadService.upload(undefined, fileData);
            });
        }).then(function () {
            _this.alertsService.createAlert('success', 'APP.INPUTS.FILE_SUCCESSFULLY_UPLOADED');
            _this.isUploading = false;
            _this.fileName = '';
        }).catch(function (error) {
            _this.isUploading = false;
            _this.fileName = '';
            _this.alertsService.createAlert('warning', 'APP.INPUTS.FILE_NOT_SUCCESSFULLY_UPLOADED', error.message);
        });
    };
    return UploadInput;
}(InputBase));
export { UploadInput };
